import styled from "@emotion/styled";

import { fontMerriweather } from "shared/lib/styles";

export const Description = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 1.4;
  text-align: start;
`;

export const DescriptionBodyText = styled.div`
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
`;

export const BoldNewsletterName = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
`;

export const RegularNewsletterName = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
`;

export const IncludingText = styled.div`
  font-weight: 400;
  font-size: 12px;
  font-style: italic;
  line-height: 1.4;
  letter-spacing: 0;
`;
